import React from "react";
import { Row, Col, Label } from "reactstrap";
import { Skeleton } from "@mui/material";

interface LoadingSkeletonFormProps {
    layout: number[][]; // Each array is a row, numbers are label widths
    inputHeight?: number; // Default 38
}

const LoadingSkeletonForm: React.FC<LoadingSkeletonFormProps> = ({
    layout,
    inputHeight = 38,
}) => {
    return (
        <div>
            {layout.map((row, rowIndex) => {
                const colSize = Math.floor(12 / row.length) || 12; // auto-adjust span
                return (
                    <>
                        <Row key={rowIndex}>
                            {row.map((labelWidth, colIndex) => (
                                <Col sm={colSize} className="mb-3" key={colIndex}>
                                    <Label className="mb-0">
                                        <Skeleton variant="text" width={labelWidth} />
                                    </Label>
                                    <Skeleton variant="rounded" height={inputHeight} />
                                </Col>
                            ))}
                        </Row>
                    </>
                );
            })}
        </div>
    );
};

export default LoadingSkeletonForm;
